<template>
  <div class="tusd-wrap wrap-bg">
    <div class="page-title">
      <i class="back-btn" @click="goBack"></i>修改银行卡账户
    </div>
    <div class="separator"></div>
    <cube-scroll>
      <div class="account-wrap">
        <div class="wrap-item">
          <span class="item-label">收款人：</span>
          <input type="text" v-model="account.BankUser" placeholder="请输入收款人" />
        </div>
        <div class="wrap-item">
          <span class="item-label">银行名称：</span>
          <span class="readonly-content">{{bankName}}</span>
        </div>
        <div class="wrap-item">
          <span class="item-label">收款账号：</span>
          <input type="text" v-model="account.BankAccount" placeholder="请输入收款账号" />
        </div>
        <div class="wrap-item">
          <span class="item-label">支行地址：</span>
          <input type="text" v-model="account.BankAddress" placeholder="请输入支行地址" />
        </div>
        <div class="wrap-item">
          <span class="item-label">单日限单量：</span>
          <span class="unit">个</span>
          <input type="text" v-model="account.DayLimitOrderCount" placeholder="请输入单日限单数量" />
        </div>
        <div class="wrap-item">
          <span class="item-label">单日总限额：</span>
          <span class="unit">元</span>
          <input type="text" v-model="account.DayLimit" placeholder="请输入单日总限额" />
        </div>
        <div class="wrap-item">
          <span class="item-label">单笔最低：</span>
          <span class="unit">元</span>
          <input type="text" v-model="account.PerLimitMin" placeholder="请输入单笔最低限额" />
        </div>
        <div class="wrap-item">
          <span class="item-label">单笔最高：</span>
          <span class="unit">元</span>
          <input type="text" v-model="account.PerLimit" placeholder="请输入单笔最高限额" />
        </div>
  
        <div class="wrap-item">
				<span class="item-label">分组管理：</span>
				<cube-select v-model="account.GroupId" :options="bankGroupOptions"  @change="selectBankGroup"></cube-select>
			</div>
        <div class="wrap-item">
          <span class="item-label">是否启用：</span>
          <div class="radio-wrap">
            <cube-radio-group
              @input="changeStatus"
              v-model="optionCheckedValue.isUseValue"
              :options="statusOptions"
              :horizontal="true"
            />
          </div>
        </div>
        <div class="wrap-item">
          <span class="item-label">订单客户：</span>
          <div class="radio-wrap">
            <cube-radio-group
            @input="changePaymentCustomerLimit"
            v-model="optionCheckedValue.paymentCustomerLimitValue"
            :options="paymentCustomerLimitOptions"
            :horizontal="true"
            />
          </div>
        </div>
        <div class="wrap-item">
          <span class="item-label">同时进账：</span>
          <div class="radio-wrap">
            <cube-radio-group
            @input="changeIsNeedLockedOrder"
            v-model="optionCheckedValue.isNeedLockedOrderValue"
            :options="isNeedLockedOrderOptions"
            :horizontal="true"
            />
          </div>
        </div>
        <div class="tusd-btn first-btn" @click="save">确认修改</div>
        <div class="tusd-btn tusd-btn-danger first-btn" @click="deleteBank">删除</div>
      </div>
    </cube-scroll>
  </div>
</template>

<script>
export default {
  name: "editAccount",
  data() {
    return {
      account: {
        BankUser: "",
        BankAccount: "",
        BankAddress: "",
        IsUse: 1,
        PerLimit:50000,
        PerLimitMin:1000,
        DayLimit:500000,
        DayLimitOrderCount:1,
        GroupId:"",
				paymentCustomerLimit:0,
				isNeedLockedOrder:0
      },
      bankName: "",
      optionCheckedValue: {
        isUseValue: "否",
        paymentCustomerLimitValue:"全部",
        isNeedLockedOrderValue:"允许"
      },
      status: [
        {
          label: "是",
          value: 1
        },
        {
          label: "否",
          value: 0
        }
      ],
      statusOptions: ["是", "否"],
      params: {},
      click: true,
      popupTxt: "",
      bankGroupOptions: [],
      paymentCustomerLimitOptions: ["全部","正常","新疆"],
			paymentCustomerLimitProp: [
				{
				label: "全部",
				value: 0
				},
				{
				label: "正常",
				value: 1
				}
				,
				{
				label: "新疆",
				value: 2
				}
			],
			isNeedLockedOrderOptions:["允许","禁止"],
			isNeedLockedOrderProp: [
				{
				label: "允许",
				value: 0
				},
        {
				label: "禁止",
				value: 1
				}
			],
    };
  },
  methods: {
    getUserByBankId(bankId) {
      this.$api.getUserByBankId(bankId).then(res => {
        let data = res.data;
        this.bankName = data.BankName;
        this.common.copyObj(this.account, data);
        this.optionCheckedValue.isUseValue = this.getProp(data.IsUse, this.status, true);
        this.optionCheckedValue.paymentCustomerLimitValue = this.getProp(data.PaymentCustomerLimit, this.paymentCustomerLimitProp, true);
        this.optionCheckedValue.isNeedLockedOrderValue = this.getProp(data.IsNeedLockedOrder, this.isNeedLockedOrderProp, true);
      });
    },
    goBack() {
      this.$router.push({ name: this.params.back });
    },
    getProp(v, o, r) {
      let prop = "";
      o.map(i => {
        if (r) {
          if (i.value == v) {
            prop = i.label;
          }
        } else {
          if (i.label == v) {
            prop = i.value;
          }
        }
      });
      return prop;
    },
    selectBankGroup(value,index,text){
			this.account.groupId=value;
		},
		getUserBankGroupList() {
			let that=this;
			this.$api.getUserBankGroups().then((res)=>{
				res.data.filter((item)=>item.PayType == 1).map(v => {
					let temp={text:v.Title,value:v.Id};
					that.bankGroupOptions.push(temp)
				})
			});
		},
    changeStatus(v) {
      this.account.IsUse = this.getProp(v, this.status);
    },
    changePaymentCustomerLimit(v) {
		  this.account.paymentCustomerLimit = this.getProp(v, this.paymentCustomerLimitProp);
		},
		changeIsNeedLockedOrder(v) {
		  this.account.isNeedLockedOrder = this.getProp(v, this.isNeedLockedOrderProp);
		},
    //确认修改银行卡信息
    save() {
      let that = this;
      if (!that.account.BankUser) {
        that.$message.popup("收款人不能空", 1000);
        return false;
      }
      if (!that.account.BankAccount) {
        that.$message.popup("银行卡号不能为空", 1000);
        return false;
      }
      // if (!that.common.checkluhnBankNo(that.account.BankAccount)) {
      //   that.$message.popup("银行卡号格式不正确，请检查", 1000);
      //   return false;
      // }
      if (!that.account.BankAddress) {
        that.$message.popup("支行地址不能为空", 1000);
        return false;
      }
      if(!that.account.GroupId){
				that.$message.popup("请选择分组管理",1000);
				return false
			}
      if (!that.account.DayLimit  || that.account.DayLimit < 500) {
				that.$message.popup("请输入单日总限额,最低金额500", 1000);
				return false
			}
			if (!that.account.PerLimitMin  || that.account.PerLimitMin < 500) {
				that.$message.popup("请输入单笔最低限额,最低金额500", 1000);
				return false
			}
			if (!that.account.PerLimit || that.account.PerLimit < 500) {
				that.$message.popup("请输入单笔最高限额,最低金额500", 1000);
				return false
			}
      if (!that.account.DayLimitOrderCount || that.account.DayLimitOrderCount < 1) {
				that.$message.popup("请输入单日限单量,最少一单", 1000);
				return false
			}
     
      if (parseInt(that.account.PerLimit) < parseInt(that.account.PerLimitMin)) {
				that.$message.popup("单笔最高不得低于单笔最低", 1000);
				return false
			}
      let toast = that.$message.toast("", 15000);
      that.$api.changeBankInfo(that.params.bankId, that.account).then(res => {
        toast.hide();
        that.$message.popup("修改银行卡成功", 1000);
        that.goBack();
      });
    },
    deleteBank() {
      let that = this;
      that.$message.confirm("提示", "您确定要删除吗？", () => {
        that.$api.deleteBank(this.params.bankId).then(res => {
          that.$message.popup("删除银行卡成功", 1000);
          that.goBack();
        });
      });
    }
  },
  created() {
    this.params = this.$store.state.routerStore.editAccount;
    if (!this.params.back) {
      this.params.back = 'accounts';
    }
    this.getUserByBankId(this.params.bankId);
    this.getUserBankGroupList();
  }
};
</script>
